import { render, staticRenderFns } from "./editCase.vue?vue&type=template&id=359592b2"
import script from "./editCase.vue?vue&type=script&lang=js"
export * from "./editCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports